module.exports = __webpack_public_path__ + "c4ed06061e31375d1ab1cebb52701391.pdf";